import React from 'react';
import { Form, Segment, Button, Dropdown, Header, List } from 'semantic-ui-react';
import Content from './Content';
import ClaimInput from './ClaimInput';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Mousetrap from 'mousetrap';
import { AllEmailMessages } from "../queries/AllEmailMessages";
import { compose, graphql } from 'react-apollo';
import { withFormik } from 'formik';
import yup from 'yup';
import Field from './Field';
import { AllClaims } from '../queries/AllClaims'
import mapConnection from '../utils/connectionMapper'
import { AllUsers } from '../queries/AllUsers'
import PathView from './PathView'
import { CreateTask } from "../mutations/CreateTask";
import withTaskTypeOptions from './TasksListComponents/withTaskTypesOptions';


const initialTaskForm = {
  userId: '',
  description: '',
  deadline: moment(),
  claimId: '',
  taskTypeId: ''
};

const ERROR_REQUIRED = 'This field is required'

const TASK_TYPES_WITH_EMAIL = [
      'handle-message',
      'assign-message'
]

const TASK_TYPES_WITHOUT_CLAIM = [
      'assign-message'
]

class TaskForm extends React.Component {
  componentDidMount = () => {
    Mousetrap.bindGlobal('esc', () => {
      if(document.activeElement.className === 'search')
        document.activeElement.blur();
      else
        this.goBack();
    })
  }

  componentWillUnmount = () => {
    Mousetrap.unbind('esc');
  }

  handleDeadlineChange = (date) => this.props.setFieldValue('deadline', date)
  handleChange = (e, { name, value }) => this.props.setFieldValue(name, value)
  handleTaskTypeChange = (e, {name, value}) => {
    this.props.setFieldValue(name, value)

    if (this.props.values.emailMessageId && !this.isTaskTypeWithEmail()) {
      this.props.setFieldValue('emailMessageId', undefined)
    }
    if (this.props.values.claimId && !this.isTaskTypeWithEmail()) {
      this.props.setFieldValue('claimId', undefined)
    }
  }
  handleClaimChange = (value) => {
    this.props.setFieldValue('claimId', value)
    this.props.setFieldValue('emailMessageId', undefined)
  }
  goBack = () => this.props.history.goBack()
  render = () => {
    const {
      AllUsers,
      errors,
      touched,
      isSubmitting,
      taskTypeOptions,
    } = this.props

    const userOptions = AllUsers.usersConnection
      ? mapConnection(AllUsers.usersConnection).map(user => {
        return {key: user.id, value: user.id, text: `${user.name} ${user.surname}`}
      }) : []

    return (
      <Content fullWidth>
        <PathView paths={[
          {name: 'Tasks', path: '/tasks'},
          {name: 'New'}
        ]}/>
        <List selection>
        </List>
        <Segment>
          <Header>{this.props.edit ? 'Edit' : 'New'} task</Header>
          <Form
            onSubmit={this.props.handleSubmit}
            loading={this.props.loading || isSubmitting}
          >
            <Field
              error={errors.description}
              touched={touched.description}
            >
              <Form.Input
                name="description"
                label="Description *"
                placeholder="Description"
                onChange={this.handleChange}
                value={this.props.values.description}
              />
            </Field>
            <Field
              error={errors.taskTypeId}
              touched={touched.taskTypeId}
            >
              <Form.Input
                label="Task Type *">
                <Dropdown fluid search selection options={taskTypeOptions}
                  name="taskTypeId"
                  onChange={this.handleTaskTypeChange}/>
              </Form.Input>
            </Field>
            <Field
              error={errors.claimId}
              touched={touched.claimId}
            >
              {this.renderClaimDropdown()}
            </Field>
            <Field
              error={errors.emailMessageId}
              touched={touched.emailMessageId}
            >
              {this.renderEmailDropdown()}
            </Field>
            <Form.Group widths="equal">
              <Field
                error={errors.userId}
                touched={touched.userId}
              >
                <Form.Input label="Assign to *">
                  <Dropdown fluid search selection options={userOptions}
                  value={this.props.values.userId}
                  name="userId"
                  onChange={this.handleChange}/>
                </Form.Input>
              </Field>
              <Field
                error={errors.deadline}
                touched={touched.deadline}
              >
                <Form.Input
                  label='Deadline *'
                  className="c-DatePicker__wrapper c-DatePicker__wrapper--form">
                  <DatePicker
                    selected={this.props.values.deadline}
                    onChange={this.handleDeadlineChange}
                    dateFormat="DD/MM/YYYY"
                    disabledKeyboardNavigation
                    customInput={<input style={{width: '100%'}}/>}/>
                </Form.Input>
              </Field>
            </Form.Group>
            <Button primary type='submit' disabled={isSubmitting}>Save</Button>
            <Button primary basic onClick={this.goBack}>Cancel</Button>
          </Form>
        </Segment>
      </Content>
    )
  }

  getTaskType = (id) => {
    const { taskTypeOptions } = this.props;
    if (!taskTypeOptions) {
      return {}
    }
    return taskTypeOptions.find(task => task.value === id)
  }

  isTaskTypeWithEmail = () => {
    return TASK_TYPES_WITH_EMAIL.includes(this.getTaskType(this.props.values.taskTypeId).name)
  }

  isTaskTypeWithClaim = () => {
    return !TASK_TYPES_WITHOUT_CLAIM.includes(this.getTaskType(this.props.values.taskTypeId).name)
  }

  renderClaimDropdown = () => {
    if(!this.props.values.taskTypeId){
      return null
    }
    if(!this.props.AllClaims.claimsConnection){
      return null
    }
    if(this.isTaskTypeWithClaim()){
      const claimsOptions = mapConnection(this.props.AllClaims.claimsConnection).map(claim => {
          const passengerTicket = claim.passengerTicket || {}
          return {key: claim.id, value: claim.id, text: `${claim.id}: ${passengerTicket.passengerFirstName} ${passengerTicket.passengerLastName}`}
        })
      return (
        <ClaimInput
          onChange={this.handleClaimChange}
          value={this.props.values.claimId}
          options={claimsOptions}
        />
      )
    }
  }

  renderEmailDropdown = () => {
    if(!this.props.values.taskTypeId){
      return null;
    }

    if(this.isTaskTypeWithEmail()){
      const emails = this.props.AllEmailMessages.allEmailMessages.filter((email) => {
        if(!this.props.values.claimId){
          return false
        }
        if(!email.claim){
          return false
        }
        return email.claim.id === this.props.values.claimId
      }).map(email => {
        return {key: email.id, value: email.id, text: `${email.from} ${email.subject}`}
      })
      return (
        <Form.Input label="E-mail">
          <Dropdown fluid search selection options={emails}
          value={this.props.values.emailMessageId}
          name="emailMessageId"
          onChange={this.handleChange}/>
        </Form.Input>
      )
    }
  }
}

const formikConfig = {
  enableReinitialize: true,
  mapPropsToValues: props => ({...initialTaskForm}),
   validationSchema: () => {
    return yup.object().shape({
      userId: yup.string().required(ERROR_REQUIRED),
      description: yup.string().required(ERROR_REQUIRED),
      deadline: yup.string().required(ERROR_REQUIRED),
      taskTypeId: yup.string().required(ERROR_REQUIRED)
    })
  },
  handleSubmit: (values, {props, setSubmitting, setErrors}) => {
    props.mutate({
      mutation: CreateTask,
      refetchQueries: ['AllTasks'],
      variables: {
        input: {
          task: values
        }
      }
    }).then(({ data }) => {
      console.log('got data', data);
      props.history.push('/tasks')
      setErrors({})
      setSubmitting(false)
    }).catch((error) => {
      console.dir(error)
      setErrors({serverError: error})
      setSubmitting(false)
      window.scrollTo(0,0)
    })
  }
}

const TaskFormWithData = compose(
  graphql(CreateTask),
  graphql(AllClaims, {name: 'AllClaims', options: {
    variables: {
      filter: {}
    }
  }}),
  graphql(AllUsers, { name: 'AllUsers', options: (props) => ({ fetchPolicy: 'cache-first' }) }),
  withTaskTypeOptions('id', 'description'),
  graphql(AllEmailMessages, {name: 'AllEmailMessages'}),
  withFormik(formikConfig)
)(TaskForm);

const EditTaskForm = (props) => <TaskFormWithData edit {...props}/>

const PredefinedTaskForm = (props) => <TaskFormWithData {...props}/>

export default TaskFormWithData
export { EditTaskForm, PredefinedTaskForm }



// WEBPACK FOOTER //
// ./src/component/TaskForm.js